<script>
/**
 * Nav-bar Component
 */
export default {
  props: {
    resource: {
      type: Object,
      required: true,
    },
    variant: {
      type: String,
      default: 'default',
      validators: value =>
          ['default', 'title'].includes(value),
    },
  },
  data() {
    return {};
  },
};
</script>

<template>
  <div :class="[$style[variant]]">
    <span>{{resource.title}}</span>
  </div>
</template>

<style module>
.title {
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;
}
</style>
